// extracted by mini-css-extract-plugin
module.exports = {"faq":"styles_faq__NwFFp","heading":"styles_heading__qVdYN"};